import { cva } from "class-variance-authority";

export const textInputVariants = cva(
  "border-input text-black bg-paper px-4 py-2.25 rounded border-2 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:border-primary placeholder:text-placeholder",
  {
    variants: {
      state: {
        default: "",
        error: "border-destructive data-[state=error]:border-destructive",
      },
      focused: {
        true: "border-primary",
        false: "",
      },
      multiline: {
        true: "",
        false: "",
      },
      width: {
        default: "w-81.75",
        full: "w-full",
      },
    },
    defaultVariants: {
      width: "default",
      focused: false,
    },
  },
);
